import { get } from 'lodash';
import { GetRegion } from 'constants.js';
import { store } from '../store';


export const GetNodeId = () => {
  const userData = localStorage.getItem('loginInfo.logged_user_data');
  return userData && JSON.parse(userData).nodeId;
};

export const GetEpgVersion = () => {
  const state = store.getState();
  const epg_version = state.epgVersion.epg_version;
  return epg_version ? epg_version : '';
};

export const tvEverywhereEnable = () => {
  if (!window.metadata || !window.metadata.epg_channels_everywhere) {
    return false;
  }
  const tvEverywhereConfig = JSON.parse(
    window.metadata.epg_channels_everywhere,
  );
  const tvEverywhere = get(
    tvEverywhereConfig,
    [GetRegion()],
    get(tvEverywhereConfig, ['default'], {}),
  );
  return get(tvEverywhere, ['enable'], false);
};

export const getParamstoEpgChannel = ()=>{
  const date = new Date().toISOString().split('.')[0].replace(/[-T:]/g, '');
  return {
    date_from: date,
    date_to: date,
    quantity: 200,
  };
};
